export default "__VITE_ASSET__DCfpRmDv__"